<template>
  <card title="user" v-loading="loading.user">
    <span slot="header">
      &nbsp;
      <span
        v-if="payload.is_deleted"
        style="color: #f56c6c; font-style: italic; font-weight: 500"
      >
        deleted
      </span>
      <span
        v-else-if="payload.is_in_paying_team"
        style="color: #67c23a; font-style: italic; font-weight: 500"
      >
        in paying team
      </span>
      <span style="color: #909399; font-style: italic; opacity: 0.5">
        {{ user.email }}
      </span>
    </span>
    <el-form label-position="left" label-width="200px" size="small">
      <el-form-item v-if="!payload.is_in_paying_team" label="Paying Status">
        <el-button @click="updatePayingStatus">Update Paying Status</el-button>
      </el-form-item>
      <el-form-item label="Created at">
        <div class="block">
          <el-date-picker v-model="payload.created_at" type="datetime">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="Name">
        <el-input v-model="payload.name" />
      </el-form-item>
      <el-form-item label="Email">
        <el-input v-model="payload.email" />
      </el-form-item>
      <el-form-item label="Credit card last digits">
        <el-input v-model="payload.credit_card_last_digits" />
      </el-form-item>
      <el-form-item label="Default team slug">
        <el-input v-model="payload.default_team_slug" />
      </el-form-item>
      <el-form-item label="Archived">
        <el-switch v-model="payload.is_archived"></el-switch>
      </el-form-item>
      <el-form-item label="Role">
        <el-select v-model="payload.role">
          <el-option value="admin" label="admin" />
          <el-option value="user" label="user" />
        </el-select>
      </el-form-item>
      <el-form-item label="Intent">
        <el-input v-model="payload.intent" />
      </el-form-item>
      <el-form-item label="Workplace type">
        <el-input v-model="payload.workplace_type" />
      </el-form-item>
      <el-form-item label="Signup landing page url">
        <el-input v-model="payload.signup_landing_page_url" />
      </el-form-item>
      <el-form-item label="Signup source">
        <el-input v-model="payload.signup_source" />
      </el-form-item>
      <el-form-item label="Referrer">
        <el-input v-model="payload.referrer" />
      </el-form-item>
      <el-form-item label="Update at">
        <div class="block">
          <el-date-picker v-model="payload.updated_at" type="datetime">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="Latest paired design tool">
        <el-input v-model="payload.latest_paired_design_tool" />
      </el-form-item>
      <el-form-item label="Password">
        <el-input v-model="password" placeholder="Password" clearable />
        <el-button @click="generateRandomPassword">Generate password</el-button>
        <el-button @click="setPassword" v-if="password" type="primary"
          >Set password</el-button
        >
      </el-form-item>
      <el-form-item label="Impersonate">
        <el-button @click="impersonate">Impersonate</el-button>
      </el-form-item>
      <el-form-item label="Unlock projects">
        <el-button @click="unlockProjects">Unlock projects</el-button>
      </el-form-item>
      <el-form-item label="Experiments">
        <el-input v-model="payload.experiments" />
      </el-form-item>
      <el-form-item label="Beta Features">
        <el-input v-model="payload.beta_features" />
      </el-form-item>
      <el-form-item label="VIP">
        <el-button @click="upgradeToProVIP" type="success">Upgrade</el-button>
        <el-button @click="downgradeFromProVIP" type="danger">
          Downgrade
        </el-button>
      </el-form-item>
      <!-- <el-form-item label="Schedule downgrade">
        <el-input v-model="scheduleDowngradeDays" placeholder="Days" type="number" />
        <el-button @click="scheduleDowngradeFromProVIP" type="danger">
          Schedule
        </el-button>
      </el-form-item> -->
      <el-form-item label="User devices">
        <el-button @click="deleteUserDevices"> Delete devices </el-button>
      </el-form-item>
      <el-form-item label="User onboarding">
        <el-button @click="deleteUserOnboarding"> Reset onboarding </el-button>
      </el-form-item>
      <el-form-item label="Revoke Figma OAuth">
        <el-button @click="revokeFigmaOAuth">Revoke</el-button>
      </el-form-item>
      <el-form-item label="Generate API Key">
        <el-button @click="generateAPIKey">Generate</el-button>
      </el-form-item>
      <el-form-item label="Use webcontainer">
        <el-switch v-model="payload.use_webcontainer"></el-switch>
      </el-form-item>
      <el-form-item label="Abuse">
        <el-button @click="reportAbuse" type="warning">
          Mark as abuse
        </el-button>
        <el-button @click="purgePlaygrounds" type="danger">
          Delete all playgrounds
        </el-button>
      </el-form-item>
      <el-form-item label="Actions">
        <el-button @click="save" type="primary">Save</el-button>
      </el-form-item>
    </el-form>
  </card>
</template>

<script>
import { pick } from "lodash";
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/Card";

export default {
  props: {
    user: { type: Object, required: true },
  },
  data() {
    return {
      scheduleDowngradeDays: 7,
      password: "",
      plan: "Pro",
      isEmailEditable: false,
      payload: {},
    };
  },
  components: {
    Card,
  },
  computed: {
    ...mapGetters(["loading"]),
  },
  async mounted() {
    this.payload = this.getUserPayload(this.user);
  },
  methods: {
    ...mapActions(["updateUser", "setUserPassword", "updateUserPlan"]),
    isValidPassword(password) {
      return password && password.length >= 8;
    },
    getUserPayload(obj) {
      const { beta_features, experiments, ...user } = obj;

      const experiments_str = experiments ? JSON.stringify(experiments) : "";
      const beta_features_str = beta_features
        ? JSON.stringify(beta_features)
        : "";
      return {
        ...user,
        ...{
          experiments: experiments_str,
          beta_features: beta_features_str,
        },
      };
    },
    generateRandomPassword(length = 8) {
      this.password = `Anima${Math.random()
        .toString(20)
        .substr(2, length)
        .toUpperCase()}`;
    },
    async setPassword() {
      const { password } = this;

      if (!this.isValidPassword(password)) {
        return this.$notify.error({
          title: "Password isn't valid",
          message: "Password should be of at least 8 characters.",
        });
      }

      try {
        await this.setUserPassword({ id: this.user.id, password });
        this.$message.success("New password set");
      } catch (e) {
        this.$notify.error({
          title: "Failed setting password",
          message: e.message,
        });
      }
    },
    async updatePayingStatus() {
      try {
        const { id } = this.user;
        await this.$api.put(`/cs/users/${id}/update_paying_status`);
        location.reload();
      } catch (e) {
        console.error(e);
      }
    },
    async impersonate() {
      try {
        const { id } = this.user;
        const {
          data: { url },
        } = await this.$api.get(`/cs/users/${id}/impersonate`);
        window.open(url, "_blank");
      } catch (e) {
        console.error(e);
      }
    },
    async deleteUserDevices() {
      try {
        const { id } = this.user;
        await this.$api.delete(`/cs/users/${id}/devices`);
        this.$message.success("Deleted devices successfully");
      } catch (e) {
        this.$notify.error({
          title: "Devices deletion failed",
          message: e.message,
        });
      }
    },
    async deleteUserOnboarding() {
      try {
        const { id } = this.user;
        await this.$api.delete(`/cs/users/${id}/user_onboardings`);
        this.$message.success("User onboarding was reset successfully");
      } catch (e) {
        this.$notify.error({
          title: "Couldn't find any onboarding related to that user",
          message: e.message,
        });
      }
    },
    async unlockProjects() {
      try {
        const { id } = this.user;
        await this.$api.get(`/user/unlock/${id}`);
      } catch (e) {
        console.error(e);
      }
    },
    async revokeFigmaOAuth() {
      try {
        const { id } = this.user;
        await this.$api.get(`/user/revoke_figma_oauth/${id}`);
        this.$message.success("Figma OAuth revoked successfully");
      } catch (e) {
        console.error(e);
        this.$message.error("Failed revoking Figma OAuth");
      }
    },

    async generateAPIKey() {
      try {
        const { id } = this.user;
        await this.$api.get(`/user/generate_api_key/${id}`);
      } catch (e) {
        console.error(e);
      }
    },
    async upgradeToProVIP() {
      try {
        const { id } = this.user;
        await this.$api.get(`/user/upgrade/${id}`);
        this.$message.success("User upgraded to VIP successfully");
      } catch (e) {
        console.error(e);
        this.$message.error("Failed upgrading user to VIP");
      }
    },
    async downgradeFromProVIP() {
      try {
        const { id } = this.user;
        await this.$api.get(`/user/downgrade/${id}`);
        this.$message.success("User downgraded from VIP successfully");
      } catch (e) {
        console.error(e);
        this.$message.error("Failed downgrading user");
      }
    },
    reportAbuse() {
      this.$confirm(
        `Archive ${this.user.email} (blocks login), unpublish ALL their playgrounds, wipe deploy assets, and post a report to #abuse. Continue?`,
        "Mark as abuse",
        {
          confirmButtonText: "Yes, mark as abuse",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const { id } = this.user;
            const { data } = await this.$api.post(`/cs/users/${id}/abuse`);
            this.$message.success(data.message || "Abuse action queued");
          } catch (e) {
            console.error(e);
            this.$message.error("Failed to mark as abuse");
          }
        })
        .catch(() => {});
    },
    purgePlaygrounds() {
      this.$confirm(
        `This will DELETE every playground owned by ${this.user.email}. A ZIP snapshot of each playground will be posted to #abuse for recovery. This action cannot be undone. Continue?`,
        "Delete all playgrounds",
        {
          confirmButtonText: "Yes, delete everything",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(async () => {
          try {
            const { id } = this.user;
            const { data } = await this.$api.post(
              `/cs/users/${id}/playgrounds/purge`
            );
            this.$message.success(data.message || "Purge queued");
          } catch (e) {
            console.error(e);
            this.$message.error("Failed to queue playground purge");
          }
        })
        .catch(() => {});
    },
    scheduleDowngradeFromProVIP() {
      this.$confirm(
        "Are you sure you want to schedule a downgrade for this user?",
        "Schedule a downgrade",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const { id } = this.user;
            await this.$api.get(
              `/user/downgrade/${id}?scheduled_for_in_days=${this.scheduleDowngradeDays}`
            );
            this.$message.success("User scheduled for downgrade successfully");
          } catch (e) {
            console.error(e);
            this.$message.error("Failed scheduling user for downgrade");
          }
        })
        .catch(() => {});
    },
    async save() {
      try {
        const { id, experiments, beta_features } = this.payload;
        const payload = pick(this.payload, [
          "created_at",
          "name",
          "credit_card_last_digits",
          "default_team_slug",
          "intent",
          "is_archived",
          // "is_stc_trial_expired",
          "premium_website_purchase_count",
          // "recent_projects",
          "referral_clicks",
          "referral_earnings",
          "referral_free_user_credit",
          "role",
          "short_id",
          "signup_landing_page_url",
          "signup_source",
          "plan",
          "sketch_to_code_start_trial_date",
          // "sns_endpoints",
          // "webhooks_urls",
          "workplace_type",
          "email",
          "latest_paired_design_tool",
          "updated_at",
          "use_webcontainer",
        ]);

        payload.experiments = experiments?.length
          ? JSON.parse(experiments)
          : null;

        payload.beta_features = beta_features.length
          ? JSON.parse(beta_features)
          : null;

        const res = await this.updateUser({ id, payload });
        if (this.$route.params.query !== res.email) {
          this.$router.push(`/customers/user/${res.email}`);
        }

        this.$message.success("Saved successfully");
      } catch (error) {
        this.$notify.error({
          title: "Save failed. :(",
          message: error.message,
        });
      }
    },
  },

  watch: {
    user(newValue) {
      this.payload = this.getUserPayload({ ...newValue });
    },
  },
};
</script>

<style scoped></style>
